import { Card } from "apps/visits/packages/ui/src/components/card";
import { Redirect } from "react-router";
import { CodeValidationForm } from "../../components/code-validation-form";
import { Layout } from "../../components/layout";
import { useCodeValidation } from "../../hooks/use-code-validation";
import { useFlowPath } from "../../hooks/use-flow-path";
import { useUserState } from "../../store/use-user-state";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";
import { useRoutes } from "../hooks/use-routes";

export const CodeValidation = () => {
  const { goToTermsAgreement, goToCatalog } = useRoutes();
  const flowPath = useFlowPath();
  const { user } = useUserState();
  const { voucherDistribution } = useVouchersDistributionState();
  const rulesAcceptanceRequired = voucherDistribution?.rulesAcceptanceRequired ?? false;

  const { handleSubmit, isLoading, errorMessage } = useCodeValidation({
    configName,
    onSuccess: rulesAcceptanceRequired ? goToTermsAgreement : goToCatalog,
  });

  if (!user?.token) {
    return <Redirect to={flowPath(routes.validateUser.raw())} />;
  }

  return (
    <Layout className="max-lg:p-4">
      <Card className="rounded-2xl border bg-background p-3 shadow-sm lg:gap-3 lg:p-4">
        <CodeValidationForm
          onSubmit={handleSubmit}
          error={errorMessage}
          isLoading={isLoading}
          configName={configName}
        />
      </Card>
    </Layout>
  );
};
